import { Poster } from './styles';

const CardSkeleton = () => {
  return <Poster />;
};

export default CardSkeleton;
